/**
 * @enum {AudienceStatus}
 */
export default {
    concept: 0,
    published: 1,
    inactive: 2
};